<template>
    <div class="container mx-4 mt-3 is-size-6-mobile">
        <h1 class="title is-1 is-size-3-mobile">Recent Submissions / Updates</h1>
        <h2 class="subtitle is-5">Last Update {{ new Date(last_update).toLocaleString() }}</h2>

        <p> <strong>Current User:</strong> {{ current_user.isAnonymous ? 'Anonymous ('+current_user.uid+')' : current_user.providerData[0].displayName }}</p>
        
        <div class="buttons">
            <a class="button is-primary" href="https://us-central1-bad-driver-award.cloudfunctions.net/accountcleanup">
                CleanUp Users
            </a>     
        </div>
        
        <div v-for="plate in recent" :key="plate.numberplate" class="my-3 card">
            <div class="card-content">
                <div class="media">
                    <div class="media-left">
                        <p class="card-header-title number-plate is-centered is-radius" 
                            style="min-width: 4.5ex; border-radius: 6px; ">
                            {{plate.numberplate}}
                        </p>
                    </div>
                    <div class="media-content">
                        <p class="title is-4">{{ Object.keys(plate.reports).length }} Reports</p>
                        <p class="subtitle is-6">Submitted by {{ Object.keys(plate.reports).join(', ') }}</p>
                    </div>
                </div>
                <div class="content">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>How bad</th>
                                <th>Feel</th>
                                <th>When</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(report,key) in plate.reports">

                                <tr :class="{ extra: report.description }" :key="key">
                                    <td>{{ report.category }}</td>
                                    <td>{{ report.seriousness }}</td>
                                    <td>{{ report.feelings }}</td>
                                    <td>{{ new Date(report.submitted_at).toLocaleString() }}</td>
                                </tr>

                                <tr v-if="report.description" :key="key+'2'">
                                    <td colspan="4" class="extra">{{ report.description }}</td>
                                </tr>
                            </template>

                            
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- <footer class="card-footer">
                <a href="#" class="card-footer-item">Save</a>
                <a href="#" class="card-footer-item">Edit</a>
                <a href="#" class="card-footer-item">Delete</a>
            </footer> -->
        </div>
    </div>
</template>


<script>
import firebase from "firebase/app"
import { mapGetters } from "vuex"; 
export default {
    data() {
        return {
            recent: [],
            last_update: new Date().getTime()
        }
    },
    computed: {
        ...mapGetters({ current_user: 'current_user' })
    },
    created() {

        var ref = firebase.database().ref('/numberplates')
        
        ref.on('child_added', snapshot => {
            this.last_update = new Date().getTime()
            this.recent.unshift(Object.assign(snapshot.val(), {numberplate: snapshot.key}))
        })

        ref.on('child_changed', snapshot => {
            this.last_update = new Date().getTime()
            var elm_index = this.recent.findIndex(item => {
                return item.numberplate == snapshot.key
            })
            var newValue = Object.assign(snapshot.val(), {numberplate: snapshot.key})
            this.recent.splice(elm_index,1,newValue)
        })

        ref.on('child_removed', snapshot => {
            this.last_update = new Date().getTime()
            var elm_index = this.recent.findIndex(item => {
                return item.numberplate == snapshot.key
            })
            this.recent.splice(elm_index,1)
        })
    }
}
</script>

<style scoped>
    .card-content .content table tr.extra td {
        border: none;
    }
    .card-content {
        padding: 0.5rem;
    }
    .container {
        padding-bottom: 5rem;
    }
</style>